
	import { defineComponent, onMounted, reactive, ref, computed } from 'vue'
	import { enableCustomizedApp } from '../request'
	import { message, Modal } from 'ant-design-vue'

	export default defineComponent({
		props: {
			value: {
				type: Object,
				default: () => ({})
			},
			sassId: {
				type: [Number, String],
				default: ''
			}
		},
		emits: ['close', 'success'],
		setup(props, { emit }) {
			const visible = ref(true)

			const copyText = (text) => {
				var textareaC = document.createElement('textarea')
				textareaC.setAttribute('readonly', 'readonly') //设置只读属性防止手机上弹出软键盘
				textareaC.value = text
				document.body.appendChild(textareaC) //将textarea添加为body子元素
				textareaC.select()
				var res = document.execCommand('copy')
				document.body.removeChild(textareaC) //移除DOM元素
				message.success('复制成功')
				return res
			}
			const submit = async () => {
				Modal.confirm({
					title: '确认提示',
					content: '确认完成以上配置吗？',
					okText: '确认',
					cancelText: '取消',
					onOk: async () => {
						try {
							await enableCustomizedApp({ id: props.sassId })
							message.success('确认成功')
							close(false)
						} catch (error) {}
					}
				})
			}
			const close = (bool: boolean) => {
				if (!bool) {
					emit('close')
				}
			}
			onMounted(async () => {})
			return {
				visible,
				copyText,
				submit,
				close
			}
		}
	})
